"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  guild: {
    id: "window.pvpInfo.battleInfo.guild",
    defaultMessage: "Guild",
    description: ""
  },
  inProgress: {
    id: "window.pvpInfo.battleInfo.status.inProgress",
    defaultMessage: "In progress",
    description: ""
  },
  occupied: {
    id: "window.pvpInfo.battleInfo.status.occupied",
    defaultMessage: "Occupied",
    description: ""
  },
  owner: {
    id: "window.pvpInfo.battleInfo.owner",
    defaultMessage: "Owner",
    description: ""
  },
  challenger: {
    id: "window.pvpInfo.battleInfo.challenger",
    defaultMessage: "Challenger",
    description: ""
  },
  battleTimeRemaining: {
    id: "window.pvpInfo.battleInfo.battleTimeRemaining",
    defaultMessage: "Battle time remaining",
    description: ""
  },
  battleWillEndIn: {
    id: "window.pvpInfo.battleInfo.battleWillEndIn",
    defaultMessage: "The battle will end in {endInTime}.",
    description: ""
  },
  battleNotEngaged: {
    id: "window.pvpInfo.battleInfo.battleNotEngaged",
    defaultMessage: "The battle is not engaged.",
    description: ""
  },
  noBattleIsSheduled: {
    id: "window.pvpInfo.battleInfo.noBattleIsSheduled",
    defaultMessage: "No battle is schedule.",
    description: ""
  },
  nextTimeOfBattle: {
    id: "window.pvpInfo.battleInfo.nextTimeOfBattle",
    defaultMessage: "Next time of battle",
    description: ""
  }
});

exports.default = _default;